import { SweetAlertIcon } from 'sweetalert2';
import { DAVIPLATA_NATIVE_OTP_CODE_LENGTH } from './General-constants';

export const EMAIL_VALIDATION = {
    email: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'invalidEmail', message: '* Ingrese un correo válido.' },
        { type: 'maxlength', message: '* El email no puede ser mayor a 150 dígitos.' },
        { type: 'minlength', message: '* El email no puede ser menor a 10 dígitos.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
};

export const PERSONAL_DATA_VALIDATION = {
    name: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'maxlength', message: '* El nombre no puede ser mayor a 45 caracteres.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
    lastName: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'maxlength', message: '* El apellido no puede ser mayor a 45 caracteres.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
    typeDI: [{ type: 'required', message: '* Este campo es requerido.' }],
    di: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
        { type: 'maxlength', message: '* El número de documento no puede ser mayor a 25 caracteres.' },
        { type: 'minlength', message: '* El número de documento no debe contener menos de 6 caracteres.' },
    ],
};

export const BUYER_INFORMATION_VALIDATIONS = {
    cellPhone: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
        { type: 'maxlength', message: '* El número de celular no puede ser mayor a 30 dígitos.' },
        { type: 'minlength', message: '* El número de celular no puede ser menor a 8 dígitos.' },
        { type: 'colMaxLength', message: '* El número de celular no puede ser mayor a 10 dígitos.' },
        { type: 'colMinLength', message: '* El número de celular no puede ser menor a 10 dígitos.' },
    ],
    ...EMAIL_VALIDATION,
};

export const CREDIT_CARD_VALIDATIONS = {
    ...PERSONAL_DATA_VALIDATION,
    creditCard: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'ccNumber', message: '* Ingrese una tarjeta valida.' },
        { type: 'minlength', message: '* El número de tarjeta no puede ser menor a 16 dígitos.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
        { type: 'invalidCreditCardNumber', message: '* Ingrese una tarjeta valida.' },
    ],
    personType: [{ type: 'required', message: '* Este campo es requerido.' }],
    expirationYear: [{ type: 'required', message: '* Este campo es requerido.' }],
    expirationMonth: [{ type: 'required', message: '* Este campo es requerido.' }],
    cvv: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'maxlength', message: '* El número de CVV tiene que tener máximo %d dígitos' },
        { type: 'minlength', message: '* El número de CVV tiene que tener mínimo %d dígitos' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
    ],
    cuotes: [{ type: 'min', message: '* Seleccione el número de cuotas' }],
};

export const PSE_VALIDATION = {
    ...PERSONAL_DATA_VALIDATION,
    personType: [{ type: 'required', message: '* Este campo es requerido.' }],
    bank: [{ type: 'required', message: '* Este campo es requerido.' }],
    address: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'pattern', message: '* La dirección no es válida.' },
        { type: 'minlength', message: '* La dirección no puede ser menor a 5 caracteres.' },
        { type: 'maxlength', message: '* La dirección no puede ser mayor a 50 caracteres.' },
    ],
};

export const ALERT_ERRORS = {
    UNEXPECTED_ERROR: 'Ha ocurrido un error mientras se procesaba tu petición',
    RETURN_URL_INVALID: 'La URL del comercio no es válida',
    DINERS_ERROR: 'Lo sentimos, en este momento no soportamos tarjetas de Diners Club. Por favor intenta con otra tarjeta.',
    THREEDS_VALIDATION_ERROR: ' Lo sentimos, en este momento no podemos procesar esta tarjeta. Por favor, utiliza otra tarjeta.',
    ERROR_TRY_AGAIN_WITH_ANOTHER_CARD: 'Pago rechazado por tu banco, utiliza otra tarjeta',
    PAYMENT_REJECTED: 'Pago rechazado',
    UNEXPECTED_ERROR_SUPPORT: 'Ha ocurrido un error. Si el problema persiste, por favor comunícate con support@payvalida.com',
    DATA_IMCOMPLETED: 'Todos los datos deben estar diligenciados',
    TRANSACTION_ERROR: 'Parece que hay un error en la transacción, comunicate con el comercio',
    ERROR_GET_BANKS: 'Fallo al traer lista de bancos',
    ERROR_COUNTRY_BEVALIDA: 'Error recibiendo lista de paises en BeValida',
    GET_TOKEN_DATA_ERROR: 'Ocurrió un error al obtener los datos de la orden',
    SORRY_ALERT: '¡Lo sentimos!',
    TYPE_WARNING: 'warning' as SweetAlertIcon,
    REQUEST_ERRORS: 'Revise los datos ingresados. Hubo un error en la información proporcionada.',
    PROCESS_WAS_NOT_FINISHED: 'El proceso no se completó',
    POP_UP_BLOCKED: 'El proceso de pago fue bloqueado por el navegador. Por favor, desbloquea las ventanas emergentes.',
    ERROR_ALREADY_PAID: 'La orden ya se encuentra pagada',
};

export const WALLET_VALIDATIONS = {
    ...EMAIL_VALIDATION,
    pass: [{ type: 'required', message: '* Este campo es requerido.' }],
    titleCo: 'BeValida Colombia',
    hiddenWallet: 'LULOBANK',
};

export const BNPL_VALIDATIONS = {
    name: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'maxlength', message: '* El nombre no puede ser mayor a 50 caracteres.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
    lastName: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'maxlength', message: '* Los apellidos no pueden ser mayor a 50 caracteres.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
    typeDI: [{ type: 'required', message: '* Este campo es requerido.' }],
    di: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
        { type: 'maxlength', message: '* El número de documento no puede ser mayor a 20 caracteres.' },
        { type: 'minlength', message: '* El número de documento no debe contener menos de 6 caracteres.' },
    ],
    email: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'invalidEmail', message: '* Ingrese un correo válido.' },
        { type: 'maxlength', message: '* El email no puede ser mayor a 200 dígitos.' },
        { type: 'minlength', message: '* El email no puede ser menor a 10 dígitos.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
    cellPhone: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
        { type: 'maxlength', message: '* El número de celular no puede ser mayor a 15 dígitos.' },
        { type: 'minlength', message: '* El número de celular no puede ser menor a 8 dígitos.' },
    ],
};

export const SPLIT_VALIDATIONS = {
    firstPayValue: [
        { type: 'required', message: 'Este campo es requerido.' },
        { type: 'min', message: 'El valor es menor que la cantidad permitida' },
        { type: 'pattern', message: 'Ingrese un valor válido' },
    ],
    secondPayValue: [
        { type: 'required', message: 'Este campo es requerido.' },
        // TODO: this validation will be decided by the business [only test]
        { type: 'min', message: 'El valor es menor que la cantidad permitida' },
    ],
};

export const DAVIPLATA_VALIDATIONS = {
    documentNumber: [
        { type: 'required', message: 'Este campo es requerido.' },
        { type: 'minlength', message: 'El número de documento no puede ser menor a 4 dígitos' },
        { type: 'maxlength', message: 'El número de documento no puede ser mayor a 16 dígitos' },
        { type: 'pattern', message: 'Ingrese un valor válido' },
    ],
    documenType: [{ type: 'required', message: 'Este campo es requerido.' }],
    codeOtp: [
        { type: 'required', message: 'Este campo es requerido.' },
        { type: 'pattern', message: 'Ingrese un valor válido' },
        { type: 'minlength', message: `El código OTP no puede ser menor a ${DAVIPLATA_NATIVE_OTP_CODE_LENGTH.MIN_MAX} dígitos` },
        { type: 'maxlength', message: `El código OTP no puede ser mayor a ${DAVIPLATA_NATIVE_OTP_CODE_LENGTH.MIN_MAX} dígitos` },
    ],
};

export const CDC_VALIDATIONS = {
    titularsName: [
        { type: 'required', message: 'Este campo es requerido.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' },
    ],
    documentNumber: [
        { type: 'required', message: 'Este campo es requerido.' },
        { type: 'minlength', message: 'El número de documento no puede ser menor a 1 dígito' },
        { type: 'maxlength', message: 'El número de documento no puede ser mayor a 15 dígitos' },
        { type: 'pattern', message: 'Ingrese un valor válido' },
    ],
    documenType: [{ type: 'required', message: 'Este campo es requerido.' }],
};

export const PUNTOS_COLOMBIA_VALIDATIONS = {
    name: [
        { type: 'required', message: '* Este campo es requerido.' },
    ],
    lastName: [
        { type: 'required', message: '* Este campo es requerido.' },
    ],
    cellPhone: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres numéricos.' },
        { type: 'maxlength', message: '* El número de celular no puede ser mayor a 10 dígitos.' },
        { type: 'minlength', message: '* El número de celular no puede ser menor a 10 dígitos.' }
    ],
    email: [
        { type: 'required', message: '* Este campo es requerido.' },
        { type: 'invalidEmail', message: '* Ingrese un correo válido.' },
        { type: 'maxlength', message: '* El email no puede ser mayor a 150 dígitos.' },
        { type: 'minlength', message: '* El email no puede ser menor a 10 dígitos.' },
        { type: 'pattern', message: '* Solo se aceptan caracteres válidos.' }
    ]
}
